import React, { useContext } from "react";
import { motion } from "framer-motion";
import { UserContext } from "../../UserContext";
import { BaseURL } from "../../BaseURL";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { HiOutlineHandThumbUp } from "react-icons/hi2";
import { HiOutlineHandThumbDown } from "react-icons/hi2";
import { Tooltip } from "react-tippy";
import { HiHandThumbDown } from "react-icons/hi2";
import { HiHandThumbUp } from "react-icons/hi2";

export default function FeedbackModal({ subTitle, feedbackModalToggle }) {
  const { darkTheme, userLoginInfo, postId } = useContext(UserContext);
  const access_token = localStorage.getItem("access_token");
  const [comment, setComment] = useState("");
  const [like, setLike] = useState(0);
  const [dislike, setDislike] = useState(0);
  const [submitDisable, setSubmitDisable] = useState(false);

  const feedbackFunc = async (e) => {
    e.preventDefault();

    const likeDislike = like === 1 ? like : dislike === 1 ? 0 : "empty";
    if (likeDislike === "empty") {
      toast.error("Please press the Like or Dislike icon");
      return;
    }
    setSubmitDisable(true);
    const formData = {
      user_id: userLoginInfo.user_id,
      post_id: postId,
      // feedback: feedback,
      feedback: likeDislike,
      comment: comment,
    };
    const res = await fetch(`${BaseURL}/codenavigator/posts/feedback`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        // Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await res.json();
    if (data?.status) {
      toast.success(
        `${userLoginInfo.user_name} Your feedback has been successfully sent`
      );

      setTimeout(()=>{

        window.location.reload();
      }, 1500)
      
      setComment("");
      setLike(0);
      setDislike(0);
      setSubmitDisable(false);
      feedbackModalToggle();
    } else {
      feedbackModalToggle();
      toast.error("You have already given feedback on this article");
      setSubmitDisable(false);
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 20, scale: 0.97 }}
      transition={{ type: "spring", stiffness: 260, damping: 24 }}
      className={`relative mx-4 w-full md:w-[560px] rounded-2xl p-6 md:p-7 shadow-2xl border ${
        darkTheme ? "bg-DarkGray border-White/10" : "bg-White border-Border"
      }`}
      onClick={(e) => e.stopPropagation()}
    >
      <form>
        <div>
          <div
            className={`text-lg md:text-xl font-semibold ${
              darkTheme ? "text-White" : "text-Text"
            }`}
          >
            Rate this content
          </div>
          <div className={`flex items-center gap-3 mt-4`}>
            <Tooltip
              title="Positive Feedback"
              position="top"
              trigger="mouseenter"
              size="regular"
              delay={500}
            >
              <button
                type="button"
                onClick={() => {
                  setLike(1);
                  setDislike(0);
                }}
                className={`flex items-center justify-center w-10 h-10 rounded-full border transition-all active:scale-[0.95] ${
                  like === 1
                    ? "bg-[#e7f8ec] border-[#1ec51e]/40 text-[#1ec51e]"
                    : darkTheme
                    ? "border-White/15 text-[#c3c3c3] hover:bg-White/5"
                    : "border-Border text-Icon hover:bg-Bg"
                }`}
              >
                {like === 1 ? (
                  <HiHandThumbUp className={`w-5 h-5`} />
                ) : (
                  <HiOutlineHandThumbUp className={`w-5 h-5`} />
                )}
              </button>
            </Tooltip>
            <Tooltip
              title="Negative Feedback"
              position="top"
              trigger="mouseenter"
              size="regular"
              delay={500}
            >
              <button
                type="button"
                onClick={() => {
                  setLike(0);
                  setDislike(1);
                }}
                className={`flex items-center justify-center w-10 h-10 rounded-full border transition-all active:scale-[0.95] ${
                  dislike === 1
                    ? darkTheme
                      ? "bg-[#3a1f1f] border-[#ec4949]/40 text-[#ec4949]"
                      : "bg-[#fdeaea] border-[#d62424]/40 text-[#d62424]"
                    : darkTheme
                    ? "border-White/15 text-[#c3c3c3] hover:bg-White/5"
                    : "border-Border text-Icon hover:bg-Bg"
                }`}
              >
                {dislike === 1 ? (
                  <HiHandThumbDown className={`w-5 h-5`} />
                ) : (
                  <HiOutlineHandThumbDown className={`w-5 h-5`} />
                )}
              </button>
            </Tooltip>
          </div>
          <div
            className={`mt-3 text-sm ${
              darkTheme ? "text-[#c3c3c3]" : "text-[#5b5b5b]"
            }`}
          >
            {subTitle}
          </div>

          <div className={`mt-5`}>
            <div className={`flex items-center justify-between mb-1.5`}>
              <label
                className={`text-xs font-medium uppercase tracking-wide ${
                  darkTheme ? "text-[#9a9a9a]" : "text-Icon"
                }`}
              >
                Comment (Optional)
              </label>
              <span
                className={`text-xs ${
                  comment.length > 400
                    ? "text-BoldRed"
                    : darkTheme
                    ? "text-[#8a8a8a]"
                    : "text-Icon"
                }`}
              >
                {comment.length}/420
              </span>
            </div>
            <textarea
              className={`py-2.5 px-3 rounded-xl w-full text-sm resize-none border transition-all focus:outline-none focus:ring-2 ${
                darkTheme
                  ? "bg-LightBlack border-White/10 text-White placeholder:text-[#8a8a8a] focus:ring-Blue4/40"
                  : "bg-Bg border-Border text-Text placeholder:text-[#9a9a9a] focus:ring-cfBlue/25"
              }`}
              rows="3"
              maxLength={"420"}
              placeholder="Maximum of 420 characters"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>

          <div
            className={`text-xs leading-relaxed mt-4 rounded-xl px-3.5 py-2.5 border-l-[3px] ${
              darkTheme
                ? "bg-White/5 border-Blue4 text-[#c3c3c3]"
                : "bg-[#f3f7ff] border-cfBlue text-[#4b5563]"
            }`}
          >
            <b className={darkTheme ? "text-White" : "text-Text"}>Note:</b>{" "}
            This feedback goes to product's documentation team and does not
            include a response. Issues that require a response should go
            through CloudFrame support.
          </div>

          <div className={`flex items-center justify-end gap-3 mt-6`}>
            <button
              className={`py-2 px-5 rounded-full text-sm font-medium transition-all active:scale-[0.97] ${
                darkTheme
                  ? "bg-transparent border border-White/15 text-White hover:bg-White/5"
                  : "bg-transparent border border-Border text-Text hover:bg-Bg"
              }`}
              onClick={() => feedbackModalToggle()}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`py-2 px-5 rounded-full text-sm font-semibold transition-all active:scale-[0.97] shadow-sm ${
                like === 1 || dislike === 1
                  ? darkTheme
                    ? "bg-Blue4 text-White hover:bg-[#00699c]"
                    : "bg-cfBlue text-White hover:bg-[#083ec2]"
                  : darkTheme
                  ? "bg-White/10 text-[#8a8a8a] cursor-not-allowed"
                  : "bg-Border text-[#9a9a9a] cursor-not-allowed"
              }`}
              onClick={(e) => feedbackFunc(e)}
              disabled={submitDisable}
            >
              {submitDisable ? "Wait..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </motion.div>
  );
}
